import { AhTimeline } from "modules/sections/AhTimeline";
import type { AhTimelineProps } from "modules/sections/AhTimeline";
import type { ReactStoryblokComponent } from "types/storyblok";

export const AhTimelineAdapter = ({
  blok: { heading, leftColumnText, rightColumnText, timeLineItems, bgStyle },
  sbEditable,
}: ReactStoryblokComponent<AhTimelineProps>) => (
  <AhTimeline
    bgStyle={bgStyle}
    heading={heading}
    leftColumnText={leftColumnText}
    rightColumnText={rightColumnText}
    timeLineItems={timeLineItems}
    sbEditable={sbEditable}
  />
);
